<template>
    <b-card :header="caption" header-class="text-left" class="text-center">
        <p v-if="loadStatus == 3" class="text-center mb-0">Data load error</p>
        <div v-else id="master-table">
            <b-modal id="edit-form-modal" modal-class="text-center" centered :title="isEdit ? 'Edit track' : 'Create track'" @ok="processItem" @show="resetModalIfCreate" ref="edit-form-modal" :key="editFormModal">
                <loading :active="submitStatus == 1 || checkFileLoadStatus == 1"></loading>
                <div>
                    <div class="invalid-feedback d-block" v-if="message">
                        {{ message }}
                    </div>
                    <b-form-group>
                        <b-form-file
                          v-model="form.original_file_path"
                          :state="Boolean(form.original_file_path)"
                          placeholder="Choose an audio file"
                          drop-placeholder="Drop an audio here"
                          @change="extractMetadata"
                          id="file"
                        ></b-form-file>
                    </b-form-group>
                    <b-form-group>
                        <b-input-group v-if="isEdit">
                            <b-input-group-prepend is-text class="item-header-text">
                                ID
                            </b-input-group-prepend>
                            <b-form-input type="number" placeholder="12" :disabled="true" :value="processingItem.id"/>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group>
                        <b-input-group>
                            <b-input-group-prepend is-text class="item-header-text">
                                <span>Original title</span>
                            </b-input-group-prepend>
                            <b-form-input type="text" id="original-title-text" placeholder="君がいるから" v-model="form.original_title" :value="processingItem.original_title" v-if="isEdit"/>
                            <b-form-input type="text" id="original-title-text" placeholder="君がいるから" v-on:input="$v.form.original_title.$touch()" :state="$v.form.original_title.$dirty ? !$v.form.original_title.$error : null" v-model="form.original_title" v-else/>
                        </b-input-group>
                        <div class="row">
                            <div class="col-3 d-block">
                            </div>
                            <div class="col-9 invalid-feedback text-left d-block" v-if="$v.form.original_title.$invalid && validation && validation.original_title">
                                {{ validation.original_title[0] }}
                            </div>
                        </div>
                    </b-form-group>
                    <b-form-group>
                        <b-input-group>
                            <b-input-group-prepend is-text class="item-header-text">
                                <span>Romaji title</span>
                            </b-input-group-prepend>
                            <b-form-input type="text" id="romaji-title-text" placeholder="Kimi ga iru kara" v-model="form.romaji_title" :value="processingItem.romaji_title" v-if="isEdit"/>
                            <b-form-input type="text" id="romaji-title-text" placeholder="Kimi ga iru kara" v-on:input="$v.form.romaji_title.$touch()" :state="$v.form.romaji_title.$dirty ? !$v.form.romaji_title.$error : null" v-model="form.romaji_title" v-else/>
                        </b-input-group>
                        <div class="row">
                            <div class="col-3 d-block">
                            </div>
                            <div class="col-9 invalid-feedback text-left d-block" v-if="$v.form.romaji_title.$invalid && validation && validation.romaji_title">
                                {{ validation.romaji_title[0] }}
                            </div>
                        </div>
                    </b-form-group>
                    <b-form-group>
                        <b-input-group>
                            <b-input-group-prepend is-text class="item-header-text">
                                <span>English title</span>
                            </b-input-group-prepend>
                            <b-form-input type="text" id="english-title-text" placeholder="Because you're around" v-model="form.english_title" :value="processingItem.english_title" v-if="isEdit"/>
                            <b-form-input type="text" id="english-title-text" placeholder="Because you're around" v-on:input="$v.form.english_title.$touch()" :state="$v.form.english_title.$dirty ? !$v.form.english_title.$error : null" v-model="form.english_title" v-else/>
                        </b-input-group>
                        <div class="row">
                            <div class="col-3 d-block">
                            </div>
                            <div class="col-9 invalid-feedback text-left d-block" v-if="$v.form.english_title.$invalid && validation && validation.english_title">
                                {{ validation.english_title[0] }}
                            </div>
                        </div>
                    </b-form-group>
                    <b-form-group>
                        <b-input-group>
                            <b-input-group-prepend is-text class="item-header-text">
                                <span>Album</span>
                            </b-input-group-prepend>
                            <model-list-select :list="albumList"
                                                v-on:input="$v.form.album_id.$touch()"
                                                :state="$v.form.album_id.$dirty ? !$v.form.album_id.$error : null"
                                                v-model="form.album_id"
                                                option-value="id"
                                                option-text="original_title"
                                                placeholder="Select album">
                            </model-list-select>
                        </b-input-group>
                        <div class="row">
                            <div class="col-3 d-block">
                            </div>
                            <div class="col-9 invalid-feedback text-left d-block" v-if="$v.form.album_id.$invalid && validation && validation.album_id">
                                {{ validation.album_id[0] }}
                            </div>
                        </div>
                    </b-form-group>
                    <b-form-group>
                        <b-input-group>
                            <b-input-group-prepend is-text class="item-header-text">
                                <span>Track no.</span>
                            </b-input-group-prepend>
                            <b-form-input type="number" id="track-no-number" placeholder="5" v-model="form.track_no" :value="processingItem.track_no" v-if="isEdit"/>
                            <b-form-input type="number" id="track-no-number" placeholder="5" v-on:input="$v.form.track_no.$touch()" :state="$v.form.track_no.$dirty ? !$v.form.track_no.$error : null" v-model="form.track_no" v-else/>
                        </b-input-group>
                        <div class="row">
                            <div class="col-3 d-block">
                            </div>
                            <div class="col-9 invalid-feedback text-left d-block" v-if="$v.form.track_no.$invalid && validation && validation.track_no">
                                {{ validation.track_no[0] }}
                            </div>
                        </div>
                    </b-form-group>
                    <b-form-group>
                        <b-input-group>
                            <b-input-group-prepend is-text class="item-header-text">
                                <span>Duration</span>
                            </b-input-group-prepend>
                            <b-form-input type="number" id="duration-number" placeholder="272" v-model="form.duration" :value="processingItem.duration" v-if="isEdit"/>
                            <b-form-input type="number" id="duration-number" placeholder="272" v-on:input="$v.form.duration.$touch()" :state="$v.form.duration.$dirty ? !$v.form.duration.$error : null" v-model="form.duration" v-else/>
                        </b-input-group>
                        <div class="row">
                            <div class="col-3 d-block">
                            </div>
                            <div class="col-9 invalid-feedback text-left d-block" v-if="$v.form.duration.$invalid && validation && validation.duration">
                                {{ validation.duration[0] }}
                            </div>
                        </div>
                    </b-form-group>
                    <b-form-group>
                        <b-input-group>
                            <b-input-group-prepend is-text class="item-header-text">
                                <span>Lyrics</span>
                            </b-input-group-prepend>
                            <b-form-textarea
                            v-if="isEdit"
                            v-model="form.lyrics"
                            :value="processingItem.lyrics"
                            placeholder="風が寄せた言葉に泳いだ心雲が運ぶあしたに弾んだ声"
                            id="lyrics-textarea"
                            rows="3">
                            </b-form-textarea>
                            <b-form-textarea
                            v-else
                            v-on:input="$v.form.lyrics.$touch()"
                            v-model="form.lyrics"
                            placeholder="風が寄せた言葉に　泳いだ心　雲が運ぶあしたに　弾んだ声"
                            id="lyrics-textarea"
                            :state="$v.form.lyrics.$dirty ? !$v.form.lyrics.$error : null"
                            rows="3">
                            </b-form-textarea>
                        </b-input-group>
                        <div class="row">
                            <div class="col-3 d-block">
                            </div>
                            <div class="col-9 invalid-feedback text-left d-block" v-if="$v.form.lyrics.$invalid && validation && validation.lyrics">
                                {{ validation.lyrics[0] }}
                            </div>
                        </div>
                    </b-form-group>
                  </div>
            </b-modal>
            <div class="row justify-content-between">
                <div class="col-2 pl-0 pr-0 mb-3 mt-2">
                    <b-input-group class="input-group-sm">
                      <b-form-select
                        @input="onChangePerPage"
                        v-model="perPage"
                        id="per_page"
                        :plain="false"
                        :options="[{ text: '15', value: 15}, { text: '30', value: 30}, { text: '50', value: 50}]"
                        size="xs"
                        value="Please select"
                        class="col-12"
                      />
                    </b-input-group>
                </div>
                <div class="col-8 text-right mb-3 mt-2 pr-0 pl-2">
                    <b-button size="sm" class="btn-action" variant="danger" @click="deleteItems()" v-if="hasChecked">
                        <i class="fa fa-remove text-white" aria-hidden="true"></i> <span class="text-white">Delete</span>
                    </b-button>
                    <b-button size="sm" class="btn-action" variant="primary" @click="prepareCreatingItem()" v-b-modal.edit-form-modal>
                        <i class="fa fa-file text-white" aria-hidden="true"></i> <span class="text-white">Create</span>
                    </b-button>
                </div>
            </div>

            <b-table
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="tableData.data"
            :fields="fields"
            :current-page="currentPage"
            per-page=0
            responsive="sm"
            show-empty
            :empty-text="emptyText"
            :busy="loadStatus == 1"
            >
                <div slot="table-busy" class="text-center text-info my-2">
                    <b-spinner class="align-middle"></b-spinner>
                </div>
                <template slot="checkbox" slot-scope="row">
                    <b-form-checkbox
                      :id="'checkbox-item-' + row.item.id"
                      :name="'checkbox-item-' + row.item.id"
                      :data-id="row.item.id"
                      class="checkbox-item"
                      @input="selectItem(row.item)"
                      value="checked"
                      unchecked-value="unchecked"
                    >
                    </b-form-checkbox>
                </template>
                <template slot="compressed_file_path" slot-scope="row" v-if="tableData.data.length > 0">
                    <audio controls v-if="row.item.original_file_path && typeof row.item.original_file_path === 'string'">
                        <source :src="'../storage/audio_files/original/' + row.item.original_file_path" type="audio/mpeg">
                    Your browser does not support the audio element.
                    </audio>
                </template>
                <template slot="created_at" slot-scope="row" v-if="tableData.data.length > 0">
                    {{ row.item.created_at.slice(0, -8) }}
                </template>
                <template slot="album" slot-scope="row" v-if="tableData.data.length > 0">
                    {{ row.item.album && row.item.album.original_title ? row.item.album.original_title : '-' }}
                </template>
                <template slot="actions" slot-scope="row">
                    <b-button size="sm" class="btn-action mt-1 mb-1" variant="warning" @click="prepareEditingItem(row.item)" v-b-modal.edit-form-modal>
                        <i class="fa fa-pencil text-white" aria-hidden="true"></i> <span class="text-white">Edit</span>
                    </b-button>
                    <b-button size="sm" class="btn-action mt-1 mb-1" variant="danger" @click="deleteItem(row.item)">
                        <i class="fa fa-trash text-white" aria-hidden="true"></i> <span class="text-white">Delete</span>
                    </b-button>
                </template>
            </b-table>
            <nav v-if="loadStatus == 2">
                <b-pagination
                v-model="currentPage"
                :total-rows="tableData.total"
                :per-page="tableData.per_page"
                class="mb-2"
                size="sm"
                >
                </b-pagination>
            </nav>
        </div>
    </b-card>
</template>

<script>
import { required, numeric } from 'validators'
import TrackAPI from '../../../../api/track.js'
import AlbumAPI from '../../../../api/album.js'
import { ModelListSelect } from 'vue-search-select'
import AdminTableUtils from './../../../../mixins/admin-table-utils'

export default {
    components: {
      ModelListSelect
    },
    name : 'cTable',
    mixins: [AdminTableUtils],
    props: {
        caption: {
            type: String,
            default: 'Table',
        },
        hover: {
            type: Boolean,
            default: false,
        },
        striped: {
            type: Boolean,
            default: false,
        },
        bordered: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
        fixed: {
            type: Boolean,
            default: false,
        },
        tableData: {
            type: Object,
            default: {},
        },
        fields: {
            type: Array,
            default: [],
        },
        loadStatus: {
            type: Number,
            default: 0
        },
        submitStatus: {
            type: Number,
            default: 2
        },
        message: {
            type: String,
            default: '',
        },
        validation: {
            type: Object,
            default: null
        },
        emptyText: {
            type: String,
            default: 'There are no records to show'
        },
    },
    validations () {
        return {
            form: {
                original_title: { required },
                romaji_title: {},
                english_title: { required },
                original_file_path: {},
                track_no: { numeric },
                lyrics: {},
                duration: { numeric },
                album_id: {}
            },
        }
    },
    data: () => {
        return {
            currentPage: 1,
            perPage: window.localStorage.getItem('per_page') || 15,
            hasChecked: false,
            isEdit: false,
            processingItem: {},
            form: {
                original_title: '',
                romaji_title: '',
                english_title: '',
                track_no: '',
                lyrics: '',
                duration: '',
                original_file_path: '',
                album_id: ''
            },
            editFormModal: 0,
            checkFileLoadStatus: 0,
            albumList: [],
            internalSubmitStatus: 2
        }
    },
    methods: {
        extractMetadata() {
            var vm = this
            var input = document.getElementById('file').files.length > 0 ? document.getElementById('file').files[0] : null;
            if (input) {
                vm.checkFileLoadStatus = 1
                mm.parseBlob(input)
                .then( metadata => {
                    // Recommend album if it was not selected
                    if (!vm.form.album_id && vm.albumList.length > 0) {
                        for (var i = 0; i < vm.albumList.length; ++i) {
                            if (vm.albumList[i].original_title == metadata.common.album) {
                                vm.form.album_id = vm.albumList[i].id
                                break
                            }
                        }
                    }
                    vm.form.original_title = metadata.common.title
                    vm.form.romaji_title = metadata.common.title
                    vm.form.english_title = metadata.common.title
                    vm.form.track_no = metadata.common.track.no
                    vm.form.duration = Math.floor(metadata.format.duration)
                    TrackAPI.checkExist(metadata.common.title, metadata.common.album, vm.form.duration)
                    .then( result => {
                        vm.checkFileLoadStatus = 2
                        if (result.data.is_existing) {
                            vm.$swal("Warning", "This track might be a duplicate of track with ID " + result.data.similar_track.id, "warning");
                        }
                    })
                    .catch((err) => {
                        console.error(err.message);
                        vm.checkFileLoadStatus = 3
                    });
                })
                .catch((err) => {
                    console.error(err.message);
                    vm.checkFileLoadStatus = 3
                });
            }
        },
        getTrackTypeText(value) {
            switch(value) {
                case 1:
                    return "Anime"
                    break
                case 2:
                    return "Game"
                    break
                case 3:
                    return "Movie"
                    break
                default:
                    return "Other"
            }
        },
        setTypeRadio(value) {
            this.form.type = $("input[name='type-radio']:checked").val()
            this.$v.form.type.$touch()
        },
        resetModalIfCreate(bvModalEvt) {
            this.$v.$reset()
            if (this.isEdit) {
                return;
            }

            this.form = {
                original_title: '',
                romaji_title: '',
                english_title: '',
                track_no: '',
                lyrics: '',
                duration: '',
                original_file_path: ''
            }
            this.$emit('reset_validation')
            this.processingItem = {}
            // Uncheck type checkboxes
            if (document.getElementById('type-anime-checkbox') && document.getElementById('type-game-checkbox') && document.getElementById('type-movie-checkbox'))
            {
                document.getElementById('type-anime-checkbox').checked = false
                document.getElementById('type-game-checkbox').checked = false
                document.getElementById('type-movie-checkbox').checked = false
            }
        },
        selectItem (item) {
            this.computeHasChecked()
        },
        computeHasChecked() {
            if ($('table .checkbox-item input').filter(':checked').length > 0) {
                this.hasChecked = true
            } else {
                this.hasChecked = false
            }
        },
        prepareCreatingItem () {
            // Let modal know this is create action
            this.isEdit = false;
            this.internalSubmitStatus = 2
        },
        prepareEditingItem (item) {
            // Let modal know this is edit action
            this.isEdit = true;
            this.internalSubmitStatus = 2
            this.forceRerender()
            this.processingItem = item
            this.form.original_title = this.processingItem.original_title || ''
            this.form.romaji_title = this.processingItem.romaji_title || ''
            this.form.english_title = this.processingItem.english_title || ''
            this.form.track_no = this.processingItem.track_no || ''
            this.form.lyrics = this.processingItem.lyrics || ''
            this.form.duration = this.processingItem.duration || ''
            this.form.original_file_path = this.processingItem.original_file_path || ''
            this.form.album_id = this.processingItem.album_id || ''
        },
        processItem (bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault()

            // Decide which logic to do
            if (this.isEdit) {
                this.editItem();
            } else {
                this.createItem();
            }
        },
        createItem () {
            var vm = this
            // Check for data validity
            this.$v.$touch()
            vm.processingItem.original_title = this.form.original_title || ''
            vm.processingItem.romaji_title = this.form.romaji_title || ''
            vm.processingItem.english_title = this.form.english_title || ''
            vm.processingItem.track_no = this.form.track_no || ''
            vm.processingItem.lyrics = this.form.lyrics || ''
            vm.processingItem.duration = this.form.duration || ''
            vm.processingItem.original_file_path = document.getElementById('file').files.length > 0 ? document.getElementById('file').files[0] : null;
            vm.processingItem.album_id = this.form.album_id || ''

            // Broadcast edit_item event
            vm.$emit('create_item', vm.processingItem, this.currentPage, this.perPage)
        },
        editItem () {
            var vm = this
            // Prepare data
            vm.processingItem.original_title = vm.form.original_title || ''
            vm.processingItem.romaji_title = vm.form.romaji_title || ''
            vm.processingItem.english_title = vm.form.english_title || ''
            vm.processingItem.track_no = vm.form.track_no || ''
            vm.processingItem.lyrics = vm.form.lyrics || ''
            vm.processingItem.duration = vm.form.duration || ''
            vm.processingItem.original_file_path = document.getElementById('file').files.length > 0 ? document.getElementById('file').files[0] : null;
            vm.processingItem.album_id = this.form.album_id || ''

            // Broadcast edit_item event
            vm.$emit('edit_item', vm.processingItem, this.currentPage, this.perPage)
        },
        deleteItem (item) {
            var vm = this
            this.$swal({
                title: 'You sure to delete this item?',
                text: "This is a soft delete mechanism. After deleting, data will no longer show here but still be remained in DB.",
                type: 'warning',
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonColor: '#f86c6b',
                cancelButtonColor: '#a4b7c1',
                confirmButtonText: 'Delete'
            }).then((result) => {
                if (result.value) {
                    vm.$emit('delete_item', item.id, this.currentPage, this.perPage)
                }
            })
        },
        deleteItems () {
            var vm = this
            this.$swal({
                title: 'You sure to delete these items?',
                text: "This is a soft delete mechanism. After deleting, data will no longer show here but still be remained in DB.",
                type: 'warning',
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonColor: '#f86c6b',
                cancelButtonColor: '#a4b7c1',
                confirmButtonText: 'Delete'
            }).then((result) => {
                if (result.value) {
                    // Gather items' ids
                    var itemIds = [];
                    $('table .checkbox-item input').filter(':checked').each(function (index) {
                        let id = $(this).data('id');
                        itemIds.push(id)
                    })
                    let itemIdsSeq = itemIds.join(',')

                    vm.$emit('delete_items', itemIdsSeq, this.currentPage, this.perPage)
                }
            })

        },
        onChangePerPage (newPerPage) {
            // Remember track's preference for per_page
            window.localStorage.setItem('per_page', newPerPage)
        },
        forceRerender() {
            this.editFormModal += 1;
        }
    },
    created() {
        var vm = this
        AlbumAPI.getAlbumList()
        .then((result) => {
            vm.albumList = result.data.album_list
        })
        .catch((error) => {
            //TODO: handle error
        })

    },
    watch: {
        currentPage: function (newVal, oldVal) {
            // Request to change data, but not on the first load
            if (oldVal) {
                this.$emit('page_changed', newVal, this.perPage)
            }
        },
        perPage: function (newVal, oldVal) {
            // Request to change data, but not on the first load
            if (oldVal) {
                this.$emit('per_page_changed', newVal)
            }
        },
        isToCloseModal: function (newVal, oldVal) {
            // Request to change data, but not on the first load
            if (newVal == 2) {
                this.$refs["edit-form-modal"].hide()
            }
        },
        submitStatus(newVal) {
           this.internalSubmitStatus = newVal
        }
    },
    computed: {
        isToCloseModal: {
            get()
            {
                return this.internalSubmitStatus
            },
            set(value)
            {
                this.internalSubmitStatus = value
            }
        }
    }
}
</script>

<style>
.track-image {
    overflow: hidden;
    height: 200px;
    width: 200px;
    border: 2px solid #49a5e3;
    margin-bottom: 25px;
    position: relative;
}

.track-image img {
    height: 200px;
    top: -100%;
    bottom: -100%;
    left: -100%;
    right: -100%;
    position: absolute;
    margin: auto;
}

.detail {
    padding: 2px;
    background: linear-gradient(90deg,#30afed,#2b54fe);
    /* border-radius: 30px; */
    bottom: 0;
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-top: auto;
    max-width: 300px;
}
.more-info {
    background-color: #fff;
    color: #2f6cf6!important;
    font-size: 18px;
    font-weight: 500;
    display: block;
    /* border-radius: 30px; */
    line-height: 45px;
    text-align: center;
    width: 100%;
    margin-bottom: 0;
    cursor: pointer;
}
.more-info:hover {
    background-color: transparent;
    color: #FFF !important;
    text-decoration: none;
}
.ui.selection.dropdown {
    border-radius: 0 !important;
}
</style>
